import { $http, Constants } from "@/store/actions/constants";

export const staticActions = {
    countries: ({ commit, state }) => {
        if (state.countries.length === 0) {
            return $http.get(`${Constants.BaseURL}/static/countries`).then(res => {
                if (res.status === 200 && res.data) {
                    commit("SET_COUNTRY_LIST", res.data);
                }
            });
        }
    },
};